module.exports = __webpack_public_path__ + "static/media/sac2trans.3268440a.png";